import http from '../services/http'
import qs from 'qs'
import { getCredentialToken } from './auth'

const BEDROCK_API_USER_ENDPOINT = '/user'
const BEDROCK_API_CUSTOMER_ENDPOINT = '/customer'

// Create a new user
export const createAccount = async ({ email, password }) => {
  const tokenResponse = await getCredentialToken()
  let response = await http.client.post(
    BEDROCK_API_USER_ENDPOINT,
    JSON.stringify({
      email,
      password,
      callback_url: `${window.location.protocol}//${window.location.host}/app/verify-email`,
      client_id: process.env.BEDROCK_API_CLIENT_TOKEN
    }),
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenResponse.data.access_token}`
      }
    }
  )

  if (response.status !== 200) {
    throw response
  }
  return response
}

// Retrieve the currently logged in user via their bearer Token
export const getUser = async (email, bearerToken) => {
  console.log(bearerToken, email)
  let url =
    BEDROCK_API_USER_ENDPOINT +
    '?' +
    qs.stringify({
      email: email,
      client_id: process.env.BEDROCK_API_CLIENT_TOKEN
    })
  console.log(url)
  let response = await http.client.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`
    }
  })
  console.log(response)

  if (response.status !== 200) {
    throw response
  }
  return response
}

// Retrieve the currently logged in user via their bearer Token
export const getCustomer = async bearerToken => {
  let response = await http.client.get(BEDROCK_API_CUSTOMER_ENDPOINT, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`
    }
  })

  if (response.status !== 200) {
    throw response
  }
  return response
}

export const googleUserInfo = async googleInfo => {
  let response = await http.googleUserInfoInstance.get(`/userinfo`, {
    headers: {
      Authorization: `Bearer ${googleInfo.access_token}`
    }
  })

  if (response.status !== 200) {
    throw response
  }
  return response
}
